// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={729}
      height={74}
      viewBox="0 0 729 74"
      {...props}
    >
      <path
        d="M679.7 61.3h-77.3V42.9h77.3v18.4zm-77.3-48.6h77.3v17.9h-77.3V12.7zM674 73.8c13.7 0 20-5.7 20-15.5v-8.6c0-2.7-1-4-3-5.7l-8.8-7.5 8.8-7.6c2-1.7 3-3 3-5.7v-7.5c0-9.8-6.3-15.5-20-15.5h-85.4v73.6H674zM530.4 61.3h-77.3V42.9h77.3v18.4zm-77.3-48.6h77.3v17.9h-77.3V12.7zm71.5 61.1c13.7 0 20-5.7 20-15.5v-8.6c0-2.7-1-4-3-5.7l-8.8-7.5 8.8-7.6c2-1.7 3-3 3-5.7v-7.5c0-9.8-6.3-15.5-20-15.5h-85.4v73.6h85.4zM377.6.2v60.5h-73.1V.2h-13.9V57c0 10.4 6.3 16.8 18.8 16.8h63.2c12.5 0 18.8-6.4 18.8-16.8V.2h-13.9zm-222.8 30V.3h-14v73.6h14V43.2h74v30.6h14V.2h-14v30h-74zm-54.4-16.9V.2H19C6.4.2.1 6.6.1 17v40C.1 67.4 6.4 73.8 19 73.8h81.5V60.7h-86V13.3h86zM722.3 1a9.7 9.7 0 0 1 5.3 5.3c.5 1.3.7 2.6.7 4a10 10 0 0 1-2.9 7.1 9.8 9.8 0 0 1-7.1 2.9 10.1 10.1 0 0 1-7.1-2.9 9.9 9.9 0 0 1-3-7.1 10 10 0 0 1 3-7.2 9.7 9.7 0 0 1 7.1-2.9c1.4 0 2.7.3 4 .8zm-7.4 1.4a8.4 8.4 0 0 0-5 7.9 8.9 8.9 0 0 0 2.3 6 8.4 8.4 0 0 0 6.1 2.6 8.3 8.3 0 0 0 7.8-5.2 8.8 8.8 0 0 0-1.8-9.5 8.4 8.4 0 0 0-6-2.5c-1.2 0-2.4.2-3.4.7zm-.2 13.7V4.4h4.4c1.3 0 2.3.3 2.9.8.6.6.9 1.3.9 2.4 0 .5 0 1-.2 1.3l-.7 1-1 .6a5 5 0 0 1-1 .3l3.4 5.2h-1.6l-3.3-5.2H716V16h-1.4zm4.6-6.4c.4 0 .8-.1 1-.3.4 0 .7-.3.9-.6.2-.2.3-.6.3-1.1 0-.4-.1-.8-.3-1-.1-.3-.3-.5-.6-.6-.3-.2-.5-.3-.9-.3l-1-.1h-2.6v4h3.2z"
        fill="#231f20"
      />
    </svg>
  );
};

const ChubbIcon = Icon;
export default ChubbIcon;
